import { TableColumnTypes } from "pages/configs/configs";

const POOL_DEVICE_COLS: TableColumnTypes[] = [
  { id: "", label: "" },
  { id: "online", label: "Status" },
  { id: "serialNumber", label: "Serial No" },
  { id: "eiSoftwareVersion", label: "Version" },
  { id: "updateAvailable", label: "Update Available" },
  { id: "deviceAlias", label: "Alias" },
  { id: "devicePool", label: "Pool Name" },
  { id: "action-col", label: "" },
];

export default POOL_DEVICE_COLS;
